var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card-content" }, [
    _c(
      "div",
      { staticClass: "card-content-search" },
      [
        !_vm.isAdmin &&
        [-1, 4, 5, 7].indexOf(_vm.entStatusCopy) > -1 &&
        _vm.pageStatusCopy == "edit"
          ? _c(
              "el-button",
              {
                directives: [
                  {
                    name: "debounce",
                    rawName: "v-debounce",
                    value: [_vm.addData, "click", 500],
                    expression: "[addData,'click',500]",
                  },
                ],
                attrs: { type: "primary", size: "small" },
              },
              [_c("i", { staticClass: "el-icon-plus" }), _vm._v("新增")]
            )
          : _vm._e(),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "card-content-table" },
      [
        _c(
          "el-table",
          {
            ref: "table",
            staticStyle: { width: "100%" },
            attrs: {
              border: "",
              data: _vm.tableList,
              align: "center",
              "header-cell-style": _vm.headerCellStyle,
              "row-key": _vm.getRowKeys,
              "row-class-name": _vm.tableRowClassName,
              "expand-row-keys": _vm.expands,
            },
          },
          [
            _c("el-table-column", {
              attrs: {
                label: "序号",
                type: "index",
                align: "center",
                width: "50",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            (_vm.currentPage - 1) * _vm.pageSize +
                              scope.$index +
                              1
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "仲裁日期",
                align: "center",
                width: "100",
                "show-overflow-tooltip": true,
                prop: "arbitrationTime",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            scope.row.arbitrationTime
                              ? _vm.formatDate(
                                  scope.row.arbitrationTime,
                                  "yyyy-MM-dd"
                                )
                              : "--"
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "仲裁内容",
                align: "center",
                "show-overflow-tooltip": true,
                prop: "arbitrationContent",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("p", [
                        _vm._v(_vm._s(scope.row.arbitrationContent || "--")),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "数据来源",
                align: "center",
                "show-overflow-tooltip": true,
                width: "100",
                prop: "dataSource",
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: "数据状态",
                align: "center",
                width: "120",
                prop: "state",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "p",
                        {
                          staticClass: "change-examine",
                          attrs: { type: "text" },
                        },
                        [
                          _c("i", {
                            class: _vm.formatDataState(
                              scope.row.dataState,
                              "class"
                            ),
                          }),
                          _c("span", [_vm._v(_vm._s(scope.row.dataStateName))]),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "登记日期",
                width: "90",
                align: "center",
                "show-overflow-tooltip": true,
                prop: "createTime",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            scope.row.createTime
                              ? _vm.formatDate(
                                  scope.row.createTime,
                                  "yyyy-MM-dd"
                                )
                              : "--"
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "作废日期",
                width: "90",
                align: "center",
                "show-overflow-tooltip": true,
                prop: "cancelTime",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            scope.row.cancelTime
                              ? _vm.formatDate(
                                  scope.row.cancelTime,
                                  "yyyy-MM-dd"
                                )
                              : "--"
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "操作",
                width: _vm.editFlag ? 140 : 100,
                "header-align": "center",
                align: "left",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: {
                            click: function ($event) {
                              return _vm.toogleExpandTrue(scope.row)
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.editFlag &&
                                (scope.row.dataState == 4 ||
                                  scope.row.dataState == 5)
                                ? "编辑"
                                : "查看"
                            )
                          ),
                        ]
                      ),
                      scope.row.dataState == 4
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.deleteData(scope.row.id)
                                },
                              },
                            },
                            [_vm._v("删除")]
                          )
                        : _vm._e(),
                      !_vm.isAdmin &&
                      [1, 2, 5].indexOf(scope.row.dataState) > -1 &&
                      ((_vm.pageStatus == "view" &&
                        [5, 6, 7].indexOf(_vm.entStatusCopy) == -1) ||
                        _vm.pageStatus != "view")
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.voidData(scope.row)
                                },
                              },
                            },
                            [_vm._v("作废 ")]
                          )
                        : _vm._e(),
                      [5, 7].indexOf(_vm.entStatusCopy) > -1 &&
                      _vm.editFlag &&
                      (scope.row.dataState == 1 || scope.row.dataState == 3)
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.copyOrChange(scope.row)
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  scope.row.dataState == 1 ? "变更" : "复制"
                                ) + " "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }